module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/battle.c94d5146.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/battle.png
// module id = 2952
// module chunks = 11